var angular = require('angular');
var _module = require('../module');

_module.component('starburst', {
    bindings: {
        color: '@',
        size: '@'
    },
    controllerAs: 'starburst',
    controller: function starburstCtrl() {
        var divider = 2.5;

        this.getWrapperSize = function getWrapperSize(size) {
            size = parseInt(size, 10);

            return (size + Math.ceil(size / divider)) + 'px';
        };

        this.getOffset = function getOffset(size) {
            size = parseInt(size, 10);

            return (Math.ceil(size / divider) / 2) + 'px';
        };
    },
    template: require('./index.html'),
    transclude: true
});
